enum ApplicationStatus {
  Draft = 'Draft',
  PendingPayment = 'PendingPayment',
  Submitted = 'Submitted',
  InReview = 'InReview',
  InformationRequired = 'InformationRequired',
  Approved = 'Approved',
  Denied = 'Denied',
}
export default ApplicationStatus;
